'use es6';

import { debounce, isEqual } from 'underscore';
import * as FoldersActions from 'DesignData/actions/finder/Folders';
import * as finderSelectors from 'DesignData/selectors/finder';
import { FINDER_OPEN_FOLDERS_FETCH } from 'DesignData/actions/ActionTypes';
let currentOpenFolderIds = null;

function saveOpenFolders(state, result, dispatch) {
  const openFolderIds = finderSelectors.getOpenFolderIds(state);

  if (currentOpenFolderIds === null) {
    currentOpenFolderIds = openFolderIds.slice();
  } else if (result.type !== FINDER_OPEN_FOLDERS_FETCH && !isEqual(openFolderIds, currentOpenFolderIds)) {
    currentOpenFolderIds = openFolderIds.slice();
    dispatch(FoldersActions.saveOpenFolders());
  }
}

const debouncedSaveOpenFolders = debounce(saveOpenFolders, 100);
export default (({
  getState,
  dispatch
}) => next => action => {
  const result = next(action);
  const state = getState();
  debouncedSaveOpenFolders(state, result, dispatch);
  return result;
});